import { Navigate, Route, Routes } from "react-router-dom";
import { Layout } from "./components/Layout";
import { RepoLayout } from "./components/RepoLayout";
import { Profile } from "./pages/Profile";
import { RepoActivity } from "./pages/Audit";
import { ChangeDetail } from "./pages/ChangeDetail";
import { CodeGraph } from "./pages/CodeGraph";
import { Docs } from "./pages/Docs";
import { Ci, CiLog } from "./pages/Ci";
import { CiRunPage } from "./pages/CiRun";
import { Commits, CommitView } from "./pages/Commits";
import { Device } from "./pages/Device";
import { Login } from "./pages/Login";
import { OAuthConsent } from "./pages/OAuthConsent";
import { NewRepo } from "./pages/NewRepo";
import { NewOrg } from "./pages/NewOrg";
import { Home, OrgPage } from "./pages/OwnerPage";
import { Overview } from "./pages/Overview";
import { RepoCode } from "./pages/RepoCode";
import { LegacyRepo, RepoRedirect, Settings, SettingsDanger, SettingsGeneral, SettingsPolicy, SettingsRemote, SettingsStorage } from "./pages/Settings";
import { SettingsAccess } from "./pages/SettingsAccess";
import { Remote } from "./pages/Remote";
import { IntentDetail, Intents } from "./pages/Intents";

export function App() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route index element={<Home />} />
        <Route path="orgs/new" element={<NewOrg />} />
        <Route path="orgs/:name" element={<OrgPage />} />
        <Route path="orgs/:name/settings/*" element={<OrgPage />} />
        <Route path="login" element={<Login />} />
        <Route path="device" element={<Device />} />
        <Route path="oauth/consent" element={<OAuthConsent />} />
        <Route path="profile" element={<Profile />} />
        <Route path="new" element={<NewRepo />} />
        <Route path=":repo" element={<LegacyRepo />} />
        <Route path=":repo/*" element={<LegacyRepo />} />
        <Route path=":owner/:repo" element={<RepoLayout />}>
          <Route index element={<RepoCode />} />
          <Route path="src/:ref/*" element={<RepoCode />} />
          <Route path="overview" element={<Overview />} />
          <Route path="intents" element={<Intents />} />
          <Route path="intents/:id" element={<IntentDetail />} />
          <Route path="review" element={<RepoRedirect to="/ci" />} />
          <Route path="changes" element={<RepoRedirect to="/ci" />} />
          <Route path="changes/:id" element={<ChangeDetail />} />
          <Route path="graph" element={<CodeGraph />} />
          <Route path="batches" element={<RepoRedirect to="/remote" />} />
          <Route path="docs" element={<Docs />} />
          <Route path="knowledge" element={<RepoRedirect to="/docs" />} />
          <Route path="commits" element={<Commits />} />
          <Route path="commit/:sha" element={<CommitView />} />
          <Route path="ci" element={<Ci />} />
          <Route path="ci/log" element={<CiLog />} />
          <Route path="ci/runs/:subject/:sha" element={<CiRunPage />} />
          <Route path="activity" element={<RepoActivity />} />
          <Route path="audit" element={<RepoRedirect to="/activity" />} />
          <Route path="remote" element={<Remote />} />
          <Route path="sync" element={<RepoRedirect to="/remote" />} />
          <Route path="github" element={<RepoRedirect to="/remote" />} />
          <Route path="settings" element={<Settings />}>
            <Route index element={<SettingsGeneral />} />
            <Route path="policy" element={<SettingsPolicy />} />
            <Route path="access" element={<SettingsAccess />} />
            <Route path="remote" element={<SettingsRemote />} />
            <Route path="github" element={<RepoRedirect to="/settings/remote" />} />
            <Route path="mirror" element={<RepoRedirect to="/settings/remote" />} />
            <Route path="storage" element={<SettingsStorage />} />
            <Route path="activity" element={<RepoRedirect to="/activity" />} />
            <Route path="audit" element={<RepoRedirect to="/activity" />} />
            <Route path="danger" element={<SettingsDanger />} />
            <Route path="*" element={<RepoRedirect to="/settings" />} />
          </Route>
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}
